export default __webpack_public_path__ + "static/media/verticals.e2bb2844.svg";